export default {
  cancel: 'Annuler',
  confirm: 'Confirmer',
  save: 'Enregistrer',
  validate: 'Valider',
  search: 'Rechercher',
  searchPlaceholder: 'Rechercher...',
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
  noData: 'Aucune donnée disponible',
  close: 'Fermer',
  refresh: 'Actualiser',
  back: 'Retour',
  retry: 'Réessayer',
  online: 'En ligne',
  offline: 'Hors ligne',
  actions: 'Actions',
  yes: 'Oui',
  no: 'Non',
  unknown: 'Inconnu',
  active: 'Actif',
  inactive: 'Inactif',
  refuse: 'Refuser',
  actionsList: {
    create: 'Créer',
    edit: 'Modifier',
    delete: 'Supprimer',
    validate: 'Valider',
    send: 'Envoyer',
    broadcast: 'Diffuser',
    configure: 'Configurer',
    backup: 'Sauvegarder'
  },
  monitoring: {
    advancedMonitoring: 'Surveillance Avancée'
  },
  status: {
    active: 'Actif',
    inactive: 'Inactif',
    pending: 'En attente',
    completed: 'Terminé',
    cancelled: 'Annulé'
  },
  ui: {
    select: {
      placeholder: 'Sélectionner...',
      selectedCount_one: '{{count}} sélectionné',
      selectedCount_other: '{{count}} sélectionnés',
      clearSelection: 'Effacer la sélection',
      searchInOptions: 'Rechercher dans les options',
      searchPlaceholder: 'Rechercher...',
      noOptionFound: 'Aucune option trouvée'
    },
    modal: {
      close: 'Fermer le dialogue'
    },
    dashboardShell: {
      doctorSpace: '⚡ Espace Pro',
      patientSpace: '✨ Mon Espace',
      securedBy: 'Sécurisé par EKOSE-RX',
      ekoseTime: 'EKOSE TIME',
      footerWatermark: '© 2026 EKOSE-RX • Plateforme Médicale de Confiance'
    }
  },
  patientSearch: {
    status: 'Statut',
    city: 'Ville',
    filterByCity: 'Filtrer par ville',
    filterByLastVisit: 'Filtrer par dernière visite',
    lastVisit: 'Dernière visite',
    clearFilters: 'Effacer les filtres',
    allStatuses: 'Tous les statuts',
    noPatientsFound: 'Aucun patient trouvé pour "{{searchTerm}}"',
    consultationCount_one: '{{count}} consultation',
    consultationCount_other: '{{count}} consultations',
    searching: 'Recherche en cours...',
  },
  healthMetrics: {
    title: 'Métriques',
    titleAccent: 'Vitales',
    history: 'Historique',
    noRealtimeData: 'Aucune donnée temps réel',
    syncDevices: 'Synchronisez vos dispositifs médicaux',
    generatingTips: 'Genèse de conseils en cours...',
    liveHds: 'Live HDS',
    types: {
      heart_rate: 'Fréquence cardiaque',
      blood_pressure: 'Tension artérielle',
      temperature: 'Température',
      weight: 'Poids',
      glucose: 'Glycémie',
      default: 'Métrique'
    },
    trends: {
      up: 'Hausse',
      down: 'Baisse',
      stable: 'Stable'
    },
    statuses: {
      normal: 'Normal',
      warning: 'Alerte',
      critical: 'Critique'
    }
  },
  authContext: {
    loginError: 'Erreur de connexion',
    registerError: 'Erreur d\'inscription',
    profileUpdateError: 'Une erreur est survenue'
  },
  errorMessages: {
    networkError: 'Erreur de connexion réseau',
    unauthorized: 'Session expirée, veuillez vous reconnecter',
    forbidden: 'Accès non autorisé',
    notFound: 'Ressource non trouvée',
    serverError: 'Erreur serveur, veuillez réessayer',
    validationError: 'Données invalides',
    tokenExpired: 'Token expiré',
    invalidCredentials: 'Identifiants invalides',
    chatConnectionFailed: 'Impossible de se connecter au chat',
    videoCallFailed: 'Échec de l\'appel vidéo',
    AUTH_INVALID_CREDENTIALS: {
      title: 'Identifiants incorrects',
      message: 'Vérifiez votre email et mot de passe'
    },
    AUTH_SESSION_EXPIRED: {
      title: 'Session expirée',
      message: 'Veuillez vous reconnecter pour continuer'
    },
    AUTH_ACCOUNT_LOCKED: {
      title: 'Compte verrouillé',
      message: 'Trop de tentatives de connexion. Réessayez dans 15 minutes'
    },
    NETWORK_OFFLINE: {
      title: 'Connexion interrompue',
      message: 'Vérifiez votre connexion internet et réessayez'
    },
    NETWORK_TIMEOUT: {
      title: "Délai d'attente dépassé",
      message: 'Le serveur met trop de temps à répondre'
    },
    NETWORK_SERVER_ERROR: {
      title: 'Erreur serveur',
      message: 'Nos serveurs rencontrent des difficultés. Réessayez plus tard'
    },
    WEBRTC_CONNECTION_FAILED: {
      title: 'Connexion vidéo impossible',
      message: 'Vérifiez vos paramètres de caméra et microphone'
    },
    WEBRTC_PERMISSION_DENIED: {
      title: 'Accès caméra/micro refusé',
      message: "Autorisez l'accès à votre caméra et microphone dans les paramètres du navigateur"
    },
    CONSULTATION_NOT_FOUND: {
      title: 'Consultation introuvable',
      message: "Cette consultation n'existe pas ou a été annulée"
    },
    APPOINTMENT_CONFLICT: {
      title: 'Créneau non disponible',
      message: 'Ce créneau est déjà pris. Choisissez un autre horaire'
    },
    APPOINTMENT_TOO_LATE: {
      title: 'Réservation impossible',
      message: "Les rendez-vous doivent être pris au moins 2h à l'avance"
    },
    APPOINTMENT_CREATED: {
      title: 'Rendez-vous confirmé',
      message: 'Votre rendez-vous a été programmé avec succès'
    },
    PROFILE_UPDATED: {
      title: 'Profil mis à jour',
      message: 'Vos informations ont été sauvegardées'
    },
    techDetails: 'Détails techniques',
    retry: 'Réessayer'
  },
  settings: {
    loadingProfile: 'Chargement de votre profil Elite...',
    elitePatient: 'Patient EKOSE Elite',
    healthProfile: 'Profil Santé',
    verifiedIdentity: 'Identité Vérifiée',
    saving: 'Enregistrement...',
    update: 'Mettre à jour',
    tabs: {
      profile: 'Mon Profil',
      security: 'Sécurité & Accès',
      emergency: 'Contacts Urgents'
    },
    eliteStatus: 'Statut Elite',
    securityLabel: 'Sécurité',
    maxSecurity: 'Maximale',
    lastCheckup: 'Dernier Checkup',
    today: "Aujourd'hui"
  },
  doctors: {
    allDoctors: 'Tous les médecins',
    generalists: 'Médecins généralistes',
    pediatricians: 'Pédiatres',
    cardiologists: 'Cardiologues',
    gynecologists: 'Gynécologues',
    dermatologists: 'Dermatologues',
    ophthalmologists: 'Ophtalmologues',
    neurologists: 'Neurologues',
    psychiatrists: 'Psychiatres',
    unspecifiedCity: 'Ville non spécifiée',
    bookAppointment: 'Rendez-vous',
    directConsultation: 'Direct',
    noDoctorAvailable: 'Aucun praticien certifié disponible',
    tryAnotherSpecialty: 'Essayez une autre spécialité ou actualisez le flux',
    planAppointment: 'Planifier RDV',
    calendarTitle: 'Calendrier',
    realTime: 'Temps réel...',
    confirmPresence: 'Confirmez votre présence après validation',
    availableHours: 'Heures Disponibles',
    selectDateOnCalendar: 'Veuillez sélectionner une date sur le calendrier',
    fullyBooked: 'Complet',
    selectAnotherDate: 'Veuillez choisir une autre date',
    cancel: 'ANNULER',
    confirmAppointment: 'CONFIRMER LE RDV',
    defaultDoctorName: 'Médecin Ekose',
    errors: {
      loadAvailabilityFailed: 'Impossible de charger les disponibilités médecins',
      loadDoctorsFailed: 'Erreur lors du chargement des médecins disponibles'
    },
    sync: 'Synchronisation',
    networkHds: 'Réseau Médical EKOSE • HDS',
    streamInterrupted: 'Flux Interrompu',
    reconnect: 'RÉTABLIR LA CONNEXION',
    directory: 'Répertoire',
    elite: 'Elite',
    syncBtn: 'SYNCHRONISER',
    doctorSelector: {
      placeholder: 'Sélectionner un médecin...',
      availableDoctor: 'Médecin disponible',
      realtime: 'Temps réel',
      reconnecting: 'Reconnexion...',
      offline: 'Hors ligne',
      refreshTooltip: 'Rafraîchir manuellement',
      autoUpdatesActive: 'Mises à jour automatiques activées',
      offlineModeWarning: 'Mode hors ligne - données peuvent être obsolètes'
    }
  },
  medicalRecords: {
    title: 'Dossier',
    titleAccent: 'Médical',
    certifiedData: 'Données Chiffrées',
    hdsHistory: 'Historique de santé centralisé HDS',
    exportButton: 'EXPORTER MON DOSSIER',
    exportSuccess: "Préparation de l'export réussie",
    exportErrorNoLink: 'Erreur: Lien de téléchargement non généré',
    exportError: "Erreur lors de l'exportation",
    searchPlaceholder: 'Rechercher un diagnostic, un médecin...',
    filterButton: 'FILTRES',
    filterTypes: "Types d'acte",
    synchronizing: 'Synchronisation sécurisée...',
    errorTitle: 'Une erreur est survenue',
    errorMessage: 'Nous ne parvenons pas à récupérer votre historique médical.',
    retryButton: 'Réessayer',
    documentCount_one: '{{count}} DOCUMENT',
    documentCount_other: '{{count}} DOCUMENTS',
    noRecord: 'Aucun dossier',
    noRecordMessage: 'Votre historique médical apparaîtra bientôt.',
    detailsTitle: 'Détails',
    detailsSubtitle: 'Examen',
    natureOfAct: "NATURE DE L'ACTE",
    certifiedHds: 'CERTIFIÉ HDS',
    responsiblePractitioner: 'PRATICIEN RESPONSABLE',
    examinationDate: "DATE D'EXAMEN",
    observations: 'OBSERVATIONS',
    archives: 'ARCHIVES',
    openInViewer: 'OUVRIR DANS LE VIEWER',
    certifyDocument: 'CERTIFIER LE DOCUMENT',
    selectRecordToView: 'Sélectionnez un examen dans votre historique pour consulter les compte-rendus et télécharger vos documents.',
    types: {
      prescription: 'Ordonnance',
      report: 'Compte-rendu',
      analysis: 'Analyse',
      imaging: 'Imagerie',
      certificate: 'Certificat'
    }
  },
  doctorDashboard: {
    stats: {
      totalConsultations: 'Consultations Totales',
      urgentTrend: 'urgents',
      uniquePatients: 'Patients Uniques',
      thisMonth: 'ce mois',
      efficiency: 'Efficacité (Complétion)',
      unreadMessages: 'Messages non lus',
      patientDefault: 'Patient',
      generalConsultation: 'Consultation générale'
    },
    realtime: {
      connected: 'Temps Réel EKOSE',
      reconnecting: 'Reconnexion...'
    },
    status: {
      initializing: 'Initialisation EKOSE PRO...',
      interrupted: 'Système Interrompu',
      syncError: 'Nous ne parvenons pas à synchroniser votre tableau de bord.',
      retry: 'Réessayer'
    },
    waitingRoom: {
      title: "Salle d'Attente",
      liveIndicator: 'EKOSE LIVE • {{count}} Patients',
      fullscreen: 'Plein Écran',
      patientLabel: 'Patient #{{id}}',
      routineConsultation: 'Consultation de routine',
      arrivedAt: 'Arrivé à',
      noPatient: 'Aucun patient en attente'
    },
    clinicalIntelligence: {
      title: 'Intelligence Clinique',
      successRate: 'Taux de Succès Réel',
      performanceAnalysis: 'Analyse Performance',
      analysisSuccess: 'Vous avez complété {{count}} consultations avec succès. Maintenez ce rythme pour optimiser votre score Elite.',
      analysisEmpty: "Commencez vos premières consultations pour activer l'analyse prédictive de votre activité.",
      detailedStats: 'Statistiques Détaillées'
    },
    onlineTeam: 'ÉQUIPE EN LIGNE'
  },
  doctorAppointments: {
    title: "Gestion de l'Agenda",
    subtitle: 'Visualisez et gérez vos consultations en temps réel',
    toast: {
      rescheduleSelectSlot: "Veuillez choisir un créneau libre pour le report.",
      validated: 'Rendez-vous validé !',
      declined: 'Demande de rendez-vous déclinée.',
      cancelled: 'Rendez-vous annulé.',
      rescheduleMode: "Mode report activé. Sélectionnez le nouveau créneau dans l'agenda.",
      rescheduled: 'Rendez-vous déplacé avec succès !',
      slotOpened: "Demande d'ouverture enregistrée (activation dimanche 07h00)",
      slotClosed: 'Créneau fermé avec succès',
      actionError: "Erreur lors de l'action"
    },
    rescheduling: {
      active: 'Report en cours',
      selectNewSlot: 'Sélectionnez le nouveau créneau pour le patient {{name}}',
      cancelBtn: 'Annuler le report'
    },
    modal: {
      titleReschedule: 'Confirmez le report',
      titleAction: 'Action sur le créneau : {{date}} à {{time}}',
      newSlotLabel: 'Nouveau Créneau',
      patientNotification: 'Le patient sera immédiatement notifié de ce changement.',
      confirmBtn: 'Confirmer le Report',
      changeSlotBtn: 'Changer de créneau',
      requestConfirm: 'Un patient demande ce rendez-vous. Voulez-vous le valider ?',
      validateBtn: 'Valider (Confirmer)',
      declineBtn: 'Refuser',
      confirmedAppointment: 'Rendez-vous confirmé avec {{name}}.',
      startConsultationBtn: 'Démarrer la consultation',
      cancelAppointmentBtn: 'Annuler le RDV',
      rescheduleBtn: 'Reporter',
      slotFree: 'Ce créneau est actuellement libre.',
      openSlotBtn: "Ouvrir dans mon agenda",
      slotOpened: 'Ce créneau est ouvert dans votre agenda.',
      closeSlotBtn: 'Fermer ce créneau'
    }
  },
  doctorPrescriptions: {
    title: 'Gestion des Prescriptions',
    subtitle: 'Interface médicale sécurisée',
    newPrescription: 'Nouvelle Prescription',
    createTitle: 'Créer une nouvelle prescription',
    stats: {
      total: 'Total prescriptions',
      thisMonth: 'Ce mois',
      pending: 'En attente validation',
      dispensed: 'Dispensées',
      urgent: 'Urgentes'
    }
  },
  adminDashboard: {
    alerts: {
      title: 'Alerte Systèmes',
      sessionExpired: 'VOTRE SESSION ADMIN A EXPIRÉ. PROTOCOLE DE SÉCURITÉ : VEUILLEZ VOUS RE-AUTHENTIFIER.',
      streamInterrupted: 'INTERRUPTION DU FLUX DE DONNÉES. LES SYSTÈMES DE SURVEILLANCE SONT MOMENTANÉMENT INDISPONIBLES.',
      resetBtn: 'RÉINITIALISER LES FLUX',
      logoutBtn: 'RETOUR AU TERMINAL DE CONNEXION'
    },
    header: {
      title: "Console d'Administration",
      subtitle: 'Infrastructure EKOSE-RX',
      statusNominal: 'SYSTÈMES NOMINAUX',
      statusAlert: 'VIGILANCE REQUISE',
      settingsTooltip: 'Paramètres de configuration'
    },
    kpis: {
      activeUsers: 'Sujets Actifs',
      medicalStaff: 'Corps Médical',
      patientFlow: 'Flux Patients',
      sessions24h: 'Sessions / 24h'
    },
    activity: {
      title: "Chronologie d'Activité",
      realtimeActive: 'TEMPS RÉEL : ACTIF'
    },
    serverPerformance: {
      title: 'Performances Serveur',
      cpuLoad: 'Charge CPU',
      ramAllocation: 'Allocation RAM',
      clusterDisk: 'Disque Cluster',
      dbLatency: 'Latence Base de Données',
      uptimeGlobal: 'Uptime Global'
    },
    userDistribution: 'Répartition des Utilisateurs',
    eventLog: {
      title: 'Journal des Événements',
      viewHistoryBtn: "VOIR L'HISTORIQUE COMPLET",
      instantT: 'INSTANT T',
      silentRadio: 'Silence Radio Systémique'
    },
    services: {
      title: 'Statut des Services',
      syncTooltip: 'Synchroniser les statuts',
      operationalStatus: 'Statut Opérationnel',
      terminateBtn: 'TERMINER',
      initializeBtn: 'INITIALISER',
      disconnectedTitle: 'Matrice Déconnectée',
      disconnectedDesc: 'Incapacité temporaire de liaison avec les serveurs de contrôle.'
    },
    quickAccess: {
      title: 'Accès Prioritaires',
      subjects: 'Sujets',
      subjectsDetail: '{{count}} profils',
      experts: 'Experts',
      expertsDetail: '{{count}} certifiés',
      sessions: 'Sessions',
      sessionsDetail: 'Flux en direct',
      vigilance: 'Vigilance',
      vigilanceDetail: 'Modération active'
    }
  },
  profile: {
    title: 'Mon',
    titleAccent: 'Profil',
    hdsEncrypted: 'Données de Santé Chiffrées • HDS',
    editBtn: 'Éditer le profil',
    cancelBtn: 'Annuler',
    changeAvatar: "Changer l'image",
    doctorCertified: 'Praticien Certifié',
    patientIdentified: 'Patient Identifié',
    verifiedAccount: 'Compte vérifié',
    saveBtn: 'Enregistrer les modifications',
    savingBtn: 'Synchronisation...',
    sections: {
      identity: 'Informations Identitaires',
      communication: 'Lignes de Communication',
      geography: 'Ancrage Géographique',
      clinical: 'Qualifications Cliniques'
    },
    fields: {
      lastName: 'Nom de Famille',
      firstName: 'Prénom',
      mobile: 'Mobile Personnel',
      gender: 'Genre',
      country: 'Pays de Résidence',
      city: 'Ville',
      specialty: 'Spécialité',
      registrationNumber: 'N° Inscription Ordre',
      selectGender: 'Sélectionner',
      selectCountry: 'Sélectionner un pays',
      selectSpecialty: 'Sélectionner une spécialité',
      genders: {
        male: 'Homme',
        female: 'Femme',
        other: 'Autre'
      }
    },
    toasts: {
      avatarSuccess: 'Identité visuelle mise à jour',
      avatarError: "Erreur lors de l'envoi de l'image",
      avatarTooHeavy: 'Fichier trop lourd (max 5MB)',
      profileSuccess: 'Profil synchronisé avec succès',
      profileLoadError: 'Impossible de charger vos données de profil.',
      profileError: 'Une erreur est survenue lors de la synchronisation de votre profil.',
      passwordsMismatch: 'Les deux mots de passe ne correspondent pas.',
      passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères.',
      passwordSuccess: 'Mot de passe mis à jour avec succès.',
      passwordError: 'Une erreur est survenue lors de la mise à jour du mot de passe.'
    },
    userNotConnected: 'Utilisateur non connecté',
    pleaseConnect: 'Veuillez vous connecter pour voir votre profil.',
    personalInfo: 'Informations personnelles',
    speciality: 'Spécialité : {speciality}',
    editProfile: 'Modifier le profil'
  },
  messages: {
    welcomeTitle: 'Messagerie',
    welcomeTitleAccent: 'EKOSE',
    welcomeDesc: 'Sélectionnez un échange pour démarrer votre consultation sécurisée. Vos données sont protégées par un cryptage de niveau militaire.',
    encryptedLabel: 'HDS Certifié • Chiffrement de Bout en Bout',
    conversationsTitle: 'Échanges',
    newConversationTitle: 'Nouvelle conversation',
    searchPlaceholder: 'Rechercher un praticien...',
    noResult: 'Aucun résultat',
    noResultDesc: 'Essayez un autre nom de praticien ou lancez une nouvelle discussion.',
    startDiscussion: 'Démarrez la discussion',
    writing: 'écrit...',
    backToList: 'Retour à la liste',
    available: 'Disponible • Consultation',
    callStarting: 'Démarrage de l\'appel {{type}} (intégration WebRTC en cours...)',
    loadingMessages: 'Chargement des messages...',
    noMessagesYet: 'Aucun message pour le moment',
    startConversationHint: 'Commencez la conversation !',
    sharedImage: 'Image partagée',
    participantTypes: {
      doctor: 'Praticien',
      patient: 'Patient'
    },
    callBtns: {
      audio: 'Appel Audio',
      video: 'Téléconsultation'
    },
    secureChannelTitle: 'Canal Sécurisé Activé',
    secureChannelDesc: 'Tous vos messages sont chiffrés et stockés sur des serveurs agréés HDS.',
    offlineSync_one: 'Synchronisation de {{count}} message...',
    offlineSync_other: 'Synchronisation de {{count}} messages...',
    offlinePending_one: '{{count}} message en attente de connexion',
    offlinePending_other: '{{count}} messages en attente de connexion',
    messageStatus: {
      read: 'Lu',
      delivered: 'Reçu',
      sending: 'Envoi...',
      sent: 'Envoyé',
      failed: 'Échec',
      retry: 'Réessayer',
      dismiss: 'Supprimer'
    },
    medicalArchive: 'Archive Médicale',
    typingIndicator: {
      practitioner: 'Le praticien',
      writing: 'écrit un message...'
    },
    input: {
      attachFile: 'Joindre un fichier',
      sendMessage: 'Envoyer le message',
      recordVoice: 'Enregistrer un message vocal',
      stopRecording: "Arrêter l'enregistrement vocal",
      emojiPanel: 'Afficher les emojis',
      quickReactions: 'Réactions Rapides',
      placeholder: 'Rédigez un message médical...',
      recordingPlaceholder: 'Enregistrement du message vocal...',
      recording: 'En Direct',
      addEmoji: "Ajouter l'emoji {{emoji}}"
    },
    chat: {
      securedStart: "Début de la conversation sécurisée",
      audioNotificationsDisabled: "🔔 Notifications sonores désactivées",
      enableAudio: "ACTIVER LE SON",
      emergencyAlertTitle: "Alerte d'Urgence Médicale",
      emergencyPlaceholder: "Décrivez l'urgence...",
      cancel: "Annuler",
      sendAlert: "Envoyer l'alerte",
      reportEmergency: "Signaler une urgence",
      writeMessagePlaceholder: "Écrire un message...",
      disconnected: 'Déconnecté du chat. Reconnexion...',
      send: 'Envoyer'
    },
    userSelector: {
      chooseDoctor: 'Choisir un Praticien',
      choosePatient: 'Sélection Patient',
      brandDirectory: 'Annuaire Sécurisé Ekose.Rx',
      searchPlaceholder: 'Rechercher par identité ou adresse mail...',
      syncing: 'Synchronisation...',
      noProfileIndexed: 'Aucun profil indexé dans cette zone',
      contactServerActive: 'Serveur de Contacts Actif',
      entityDetected_one: '{{count}} ENTITÉ DÉTECTÉE',
      entityDetected_other: '{{count}} ENTITÉS DÉTECTÉES'
    }
  },
  appointments: {
    bookingUnit: 'UNITÉ DE RÉSERVATION',
    hdsGrade: 'Grade Médical HDS',
    planTitle: 'Planifier',
    planTitleAccent: 'RDV',
    myAgenda: 'MON AGENDA',
    selected: 'SÉLECTIONNÉ',
    changeSlot: 'Changer le créneau',
    summaryTitle: 'RÉCAPITULATIF',
    summarySubtitle: 'PATIENT',
    reserveTitle: 'RÉSERVER',
    reserveTitleAccent: 'VOTRE SOIN',
    reserveDesc: 'Choisissez un expert dans la liste pour accéder à son agenda en temps réel et valider votre créneau.',
    dateLabel: 'DATE',
    timeLabel: 'HORAIRE',
    selectSlotHint: 'Sélectionnez un créneau',
    selectSlotHintAccent: 'disponible',
    selectSlotHintSuffix: 'pour activer la réservation.',
    calendar: 'Le Calendrier',
    schedule: "L'Horaire",
    confirmTitle: 'Confirmer',
    confirmTitleAccent: 'RDV',
    hdsCheckLabel: 'Vérification de sécurité HDS intégrale',
    cancelBtn: 'ANNULER',
    encryptingBtn: 'CHIFFREMENT...',
    confirmBtn: 'VALIDER LA RÉSERVATION',
    successTitle: 'DEMANDE',
    successTitleAccent: 'EXPÉDIÉE',
    successDesc: 'Praticien notifié par tunnel sécurisé HDS. Validation nécessaire.',
    returnCalendar: 'RETOUR AU CALENDRIER',
    availabilitiesTitle: 'Flux',
    availabilitiesTitleAccent: 'Disponibilités',
    loadingCalendar: 'Interrogation des agendas praticiens...',
    card: {
      noAppointment: 'Aucun rendez-vous',
      bookAppointment: 'PRENDRE RDV',
      timeUntil: {
        days_one: 'dans {{count}} jour',
        days_other: 'dans {{count}} jours',
        hours_one: 'dans {{count}} heure',
        hours_other: 'dans {{count}} heures',
        minutes_one: 'dans {{count}} minute',
        minutes_other: 'dans {{count}} minutes'
      },
      certifiedPractitioner: 'PRATICIEN CERTIFIÉ',
      doctorNamePrefix: 'Dr. {{name}}',
      patientNamePrefix: 'PATIENT : {{name}}',
      medicalStaff: 'PERSONNEL MÉDICAL',
      generalConsultation: 'Consultation Générale',
      standardFollowUp: 'Suivi médical standard',
      status: {
        confirmed: 'CONFIRMÉ',
        scheduled: 'PROGRAMMÉ',
        in_progress: 'EN COURS',
        completed: 'TERMINÉ',
        cancelled: 'ANNULÉ'
      },
      sessionDate: 'Date de Session',
      preciseTime: 'Heure Précise',
      joinConsultation: 'ACCÉDER À LA CONSULTATION',
      reschedule: 'REPLANIFIER',
      dateLabel: 'Date',
      timeLabel: 'Horaire',
      encrypted: 'HDS : Crypté',
      joinRoom: 'REJOINDRE LA SALLE',
      details: 'DÉTAILS'
    },
    calendarGrid: {
      today: "Aujourd'hui",
      hour: 'Heure',
      patient: 'Patient',
      reserve: 'Réserver',
      status: {
        validated: 'Validé',
        pending: 'Attente'
      },
      legend: {
        free: 'Libre / Basique',
        open: 'Ouvert (Réservable)',
        pending: 'Demandé (Attente)',
        confirmed: 'Validé (Confirmé)'
      }
    }
  },
  praticienSelection: {
    title: 'Praticiens',
    titleAccent: 'Experts',
    searchPlaceholder: 'Rechercher par nom ou spécialité...',
    filterBySpecialty: 'FILTRER PAR SPÉCIALITÉ',
    loadingText: 'Chargement sécurisé de la base praticiens...',
    noResult: "Nous n'avons trouvé aucun résultat correspondant à votre recherche.",
    verified: 'Vérifié'
  },
  prescriptions: {
    title: 'Mes',
    titleAccent: 'Ordonnances',
    subtitle: 'Centralisez et gérez vos prescriptions médicales avec une sécurité de grade militaire.',
    exportBtn: 'Exporter Coffre-Fort',
    urgentHelp: 'Aide Urgente',
    searchPlaceholder: 'Rechercher une ordonnance, un médecin...',
    advancedFilters: 'Filtres Avancés',
    stats: {
      active: 'Actives',
      activeSub: 'Valides ce mois',
      toRenew: 'À Renouveler',
      toRenewSub: 'Action requise',
      history: 'Historique',
      historySub: 'Dernière : 15 Mar'
    },
    security: {
      title: 'Sécurité Médicale de Pointe',
      desc: 'Toutes vos ordonnances sont authentifiées via la blockchain EKOSE et chiffrées en AES-256. Notre infrastructure est certifiée HDS (Hébergeur de Données de Santé) pour une confidentialité totale.',
      certifyBtn: 'Certifier Document'
    },
    list: {
      active: 'Active',
      expired: 'Expirée',
      renewalNeeded: 'À renouveler',
      dosage: 'Dosage',
      frequency: 'Fréquence',
      duration: 'Durée',
      start: 'Début',
      renew: 'Renouveler',
      details: 'Détails',
      noPrescription: 'Aucune prescription',
      emptyVault: 'Votre coffre-fort médical est vide. Toutes vos futures ordonnances apparaîtront ici.'
    }
  },
  checkout: {
    missingId: 'Identifiant de téléconsultation manquant',
    title: 'Règlement de votre consultation',
    consultationNum: 'Consultation #{{id}}',
    summary: 'Récapitulatif',
    item: 'Téléconsultation EKOSE',
    serviceFees: 'Frais de service (Inclus)',
    total: 'Total à payer',
    payBtn: 'Procéder au paiement',
    successMsg: 'Paiement confirmé ! Vous allez être redirigé.'
  },
  teleconsultation: {
    connecting: 'Connexion en cours...',
    video: 'VIDÉO',
    chat: 'CHAT',
    secureChat: 'Chat Médical Sécurisé',
    hdsEncrypted: 'Ligne Chiffrée HDS',
    sessionId: 'ID SESSION: #{{id}}',
    leaveBtn: 'Quitter la consultation',
    patientName: 'Patient',
    doctorNameDefault: 'Dr. Martin',
    ended: 'Téléconsultation terminée',
    title: 'Téléconsultation EKOSE',
    chatShortcut: 'Chat (Ctrl+M)',
    fullscreenShortcut: 'Plein écran (Ctrl+Enter)',
    quitShortcut: 'Quitter (Ctrl+Q)',
    chatTab: 'Chat',
    defaultUser: 'Utilisateur',
    patientLabel: 'Patient :',
    doctorLabel: 'Médecin :',
    shortcutsText: 'Raccourcis: Ctrl+M (Chat) • Ctrl+Enter (Plein écran) • Ctrl+Q (Quitter)'
  },
  doctorNewConsultation: {
    generalMedicine: 'Médecine Générale',
    loadingError: 'Erreur lors du chargement du patient',
    patientNotFound: 'Patient non trouvé',
    patientIntrouvable: 'Patient introuvable',
    unauthenticated: 'Utilisateur non authentifié',
    validationError: 'Erreur de validation',
    unauthorized: 'Accès non autorisé',
    authError: "Erreur d'autorisation",
    creationError: 'Erreur lors de la création de la consultation',
    loadingPatient: 'Chargement du patient...',
    backToList: 'Retour à la liste',
    title: 'Nouvelle Consultation',
    subtitle: 'Configurez et lancez l\'appel avec votre patient.',
    medicalRecord: 'Dossier Médical du Patient',
    patientIdentity: 'Identité Patient',
    age: 'Âge',
    years: 'ans',
    gender: 'Sexe',
    medicalHistory: 'Antécédents médicaux',
    allergies: 'Allergies Signalées',
    quickStartTitle: 'Démarrage rapide depuis la file d\'attente',
    quickStartDesc: 'Cette action génère instantanément la salle d\'attente et fait entrer automatiquement le prochain patient prioritaire.',
    communicationChannel: 'Canal de communication',
    videoEnabled: 'Caméra vidéo activée',
    audioOnly: 'Appel Audio Uniquement',
    notesLabel: 'Notes Pré-Consultation (optionnel)',
    notesPlaceholder: 'Précisez un motif d\'appel contextuel...',
    initializingCall: 'Initialisation d\'appel sécurisé...',
    startCallBtn: 'Démarrer la consultation vidéo'
  },
  doctorDirectory: {
    loadingError: 'Erreur lors du chargement des médecins',
    loadingErrorDetails: 'Erreur lors du chargement des médecins.',
    peerRequestReason: 'Demande de consultation entre confrères',
    creationError: 'Erreur lors du démarrage de la consultation',
    loadingDoctors: 'Chargement des médecins...',
    title: 'Annuaire des Médecins',
    subtitle: 'Retrouvez et consultez vos confrères d\'urgences de la plateforme.',
    securedNetwork: 'Réseau Médical Sécurisé',
    generalMedicine: 'Médecine Générale',
    videoconference: 'Visioconférence'
  },
  doctorPatientList: {
    loadingError: 'Impossible de charger les patients.',
    initializing: 'Initialisation Data Patient...',
    medicalIntelligence: 'Intelligence Médicale',
    title: 'Ma Patientèle',
    avgVigilance: 'Score Moyen Vigilance',
    searchPlaceholder: 'RECHERCHER UN PATIENT PAR NOM OU IDENTIFIANT...',
    total: 'Total Patients',
    activeFiles: 'Files Actives',
    highVigilance: 'Vigilance Haute',
    lastMonth: 'Dernier Mois',
    vigilance: 'Vigilance',
    locationNotProvided: 'Localisation non renseignée',
    record: 'Dossier',
    followUp: 'Suivi',
    noMatch: 'Aucune correspondance',
    noMatchDesc: 'Affinez votre recherche ou actualisez la base de données.'
  },
  doctorSettings: {
    accountType: 'Compte Praticien EKOSE',
    tabs: {
      profile: 'Profil Pro',
      availability: 'Mon Planning',
      security: 'Sécurité'
    },
    professionalInfo: 'Informations Professionnelles',
    licenseNumber: 'Numéro de licence',
    identityContact: 'Identité & Contact',
    proPhone: 'Téléphone Pro',
    weeklyAvailability: 'Planning Hebdomadaire',
    securitySignature: 'Sécurité & Signature',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmation',
    certifyUpdate: 'Certifier & Mettre à jour',
    professionalStatus: 'Statut Professionnel',
    office: 'Cabinet',
    appointmentChannels: 'Canaux de Prise de RDV',
    immediateAppointment: 'Prise de RDV immédiate',
    teleconsultations: 'Téléconsultations',
    homeVisits: 'Visites à domicile',
    toasts: {
      profileLoadError: 'Erreur lors du chargement du profil',
      profileUpdateError: 'Erreur lors de la mise à jour du profil',
      passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
      passwordSuccess: 'Mot de passe modifié avec succès',
      passwordError: 'Erreur lors du changement de mot de passe'
    },
    placeholders: {
      yourProfile: 'Votre Profil',
      specialtyUndefined: 'Spécialité non définie',
      selectOption: 'Choisir...',
      licenseExample: 'Ex: 123456789'
    },
    weeklyAvailabilityManager: {
      title: "Planning Hebdomadaire",
      subtitle: "Vos modifications sont enregistrées et applicables immédiatement",
      loadError: "Erreur lors du chargement des disponibilités",
      saveSuccess: "Planning mis à jour avec succès et immédiatement effectif",
      saveError: "Erreur de sauvegarde",
      saveBtn: "Enregistrer le planning",
      addSlotBtn: "Ajouter une plage",
      noSlot: "Aucune plage définie pour ce jour",
      to: "à",
      activeLabel: "Actif",
      deleteTitle: "Supprimer la plage",
      days: {
        "0": "Dimanche",
        "1": "Lundi",
        "2": "Mardi",
        "3": "Mercredi",
        "4": "Jeudi",
        "5": "Vendredi",
        "6": "Samedi"
      }
    }
  },
  doctorPatientRecords: {
    videoCall: 'Appel vidéo',
    teleconsultation: 'Téléconsultation',
    appointment: 'Rendez-vous',
    status: {
      completed: 'Terminée',
      inProgress: 'En cours',
      scheduled: 'Programmée',
      cancelled: 'Annulée',
      unknown: 'Inconnu'
    },
    dataNotFound: 'Données introuvables.',
    medicalRecord: 'Dossier Médical',
    patientFile: 'Fiche Patient',
    email: 'Email',
    residence: 'Résidence',
    registeredOn: 'Inscrit le',
    lastVisit: 'Dernière visite',
    total: 'Total',
    completedCount: 'Terminées',
    carePath: 'Parcours de Soins',
    reason: 'Motif consultation',
    diagnosis: 'Diagnostic',
    prescription: 'Prescription',
    notes: 'Observations / Notes',
    emptyRecord: 'Dossier Vide',
    emptyRecordDesc: 'Aucune consultation archivée.',
    startFollowUp: 'Démarrer un suivi',
    reference: 'Réf :'
  },
  peerLobby: {
    cancelled: 'La consultation a été annulée ou refusée.',
    completed: 'Cette consultation est déjà terminée.',
    errorFetch: 'Impossible de récupérer les informations de la consultation.',
    peerJoined: 'Votre confrère a rejoint la consultation !',
    peerCancelled: 'La demande de consultation a été annulée.',
    oops: 'Oups !',
    backToDashboard: 'Retour au tableau de bord',
    initializing: 'Initialisation...',
    waitingPeer: 'En attente de votre confrère...',
    loadingDetails: 'Nous récupérons les détails de votre demande.',
    waitingDetails: 'Votre demande a été envoyée. Nous vous redirigerons dès que la connexion sera établie.',
    tip: '💡 Astuce : Vous pouvez rester sur cette page, la connexion se fera automatiquement.'
  },
  onboarding: {
    validationError: 'Veuillez remplir les informations essentielles (Nom, Spécialité, Ville, Téléphone)',
    successMsg: 'Profil configuré avec succès',
    updateError: 'Erreur lors de la mise à jour du profil',
    verification: 'Vérification',
    accreditedPractitioner: 'Praticien Accrédité',
    initCabinet: 'Initialisation du Cabinet Digital',
    welcome: 'BIENVENUE CHEZ',
    intro: 'Honorés de vous compter parmi nous. Veuillez finaliser la configuration de votre profil professionnel pour activer vos services.',
    medicalExpertise: 'Expertise Médicale',
    rppsLicense: 'N° de Licence RPPS',
    officeLocation: 'Localisation du Cabinet',
    regionState: 'Région / État',
    validateNext: 'Valider mon Profil & Passer à l\'Agenda',
    finalSequence: 'Séquence Finale',
    temporalGrid: 'Maillage',
    temporalGridAccent: 'Temporel',
    finishRegistration: 'Finaliser mon Inscription',
    tip: 'Vous pourrez modifier vos disponibilités à tout moment dans vos paramètres',
    footerBranding: '© 2026 Ekose.Rx — Plateforme de Téléconsultation Hautement Sécurisée',
    placeholders: {
      doctorName: 'Dr. Votre Nom',
      selectOption: 'Sélectionner...',
      regionExample: 'Ex: Littoral',
      cityExample: 'Ex: Cotonou',
      relativeName: 'Nom du proche',
      relationExample: 'Ex: Conjoint',
      licenseExample: '10101234567'
    }
  },
  notifications: {
    backToDashboard: 'Retour au dashboard',
    title: 'Notifications Médicales',
    subtitle: 'Gérez vos alertes et notifications médicales',
    typesTitle: 'Types de notifications',
    types: {
      emergency: 'Urgence :',
      emergencyDesc: 'Nécessite une action immédiate',
      important: 'Important :',
      importantDesc: 'Action requise dans les plus brefs délais',
      info: 'Information :',
      infoDesc: 'Pour votre information',
      success: 'Succès :',
      successDesc: "Confirmation d'action"
    },
    actionsTitle: 'Actions rapides',
    actions: {
      act: 'Cliquez sur "Agir" pour les actions requises',
      markAsRead: 'Marquez comme lue pour archiver',
      filter: 'Utilisez les filtres pour organiser',
      preferences: 'Configurez vos préférences'
    },
    unreadCount_one: '{{count}} non lue',
    unreadCount_other: '{{count}} non lues',
    emergencyCount_one: '{{count}} urgence',
    emergencyCount_other: '{{count}} urgences',
    noNotifications: 'Aucune notification',
    priority: {
      high: 'Haute',
      medium: 'Moyenne',
      low: 'Basse'
    },
    actionRequired: 'Action requise',
    markAsReadBtn: 'Marquer comme lue',
    actBtn: 'Agir',
    markAllAsRead: 'Tout marquer comme lu',
    totalNotifications_one: '{{count}} notification au total',
    totalNotifications_other: '{{count}} notifications au total',
    timeSince: {
      justNow: "À l'instant",
      minutes: 'Il y a {{count}} min',
      hours: 'Il y a {{count}}h',
      days: 'Il y a {{count}}j'
    }
  },
  videoCall: {
    initializing: 'Initialisation Agora...',
    connectionError: 'Erreur de connexion',
    myCameraOff: 'Ma Caméra Off',
    you: 'Vous',
    signalQuality: 'Qualité du signal',
    cameraDisabled: 'Caméra désactivée',
    waitingInterlocutor: "Attente de l'interlocuteur...",
    remote: 'Distant',
    unmuteMic: 'Réactiver le micro',
    muteMic: 'Couper le micro',
    stopCamera: 'Couper la caméra',
    startCamera: 'Activer la caméra',
    endCall: "Terminer l'appel"
  },
  presence: {
    available: 'Disponible',
    busy: 'Occupé',
    offline: 'Hors ligne',
    away: 'Absent'
  },
  offlineNotification: {
    connectedTitle: 'Connexion rétablie',
    disconnectedTitle: 'Mode hors ligne',
    syncing: 'Synchronisation en cours...',
    limitedFeatures: 'Certaines fonctionnalités peuvent être limitées'
  },
  pwa: {
    installTitle: 'Installer EKOSE',
    installSubtitle: "Accès rapide depuis votre écran d'accueil",
    closeInstall: "Fermer la fenêtre d'installation",
    features: {
      offline: 'Accès hors ligne aux fonctionnalités essentielles',
      notifications: 'Notifications push pour vos rendez-vous',
      mobile: 'Interface optimisée pour mobile',
      speed: 'Démarrage plus rapide'
    },
    installBtn: 'Installer',
    laterBtn: 'Plus tard',
    connectionRequired: "Connexion requise pour l'installation",
    updateTitle: 'Mise à jour disponible',
    updateSubtitle: "Une nouvelle version d'EKOSE est prête",
    closeUpdate: 'Fermer la fenêtre de mise à jour',
    updateBtn: 'Mettre à jour',
    ignoreBtn: 'Ignorer',
    offlineLimited: '⚠️ Mode hors ligne - Fonctionnalités limitées'
  },
  devicePreflight: {
    errors: {
      notAllowed: "Veuillez autoriser l'accès à la caméra et au microphone via le cadenas de votre navigateur.",
      notReadable: "Périphériques déjà utilisés par une autre application (Zoom, Teams...).",
      notFound: "Aucune caméra ou microphone détecté sur ce terminal.",
      failedInit: "Échec de l'initialisation optique : "
    },
    title: 'Vérification',
    titleAccent: 'Technique',
    subtitle: "Séquence d'optimisation de flux HDS",
    accessInterrupted: 'Accès Interrompu',
    initializing: 'Initialisation Optique...',
    directSignal: 'Signal Direct • HD',
    optics: 'Optique',
    acoustics: 'Acoustique',
    defaultBtn: "Entrer dans la salle d'attente"
  },
  screenSharing: {
    notSupported: 'Le partage d\'écran n\'est pas supporté par ce navigateur',
    stopSharing: 'Arrêter le partage',
    shareScreen: 'Partager l\'écran',
    switchSource: 'Changer la source d\'écran',
    settingsTitle: 'Paramètres du partage d\'écran',
    quality: 'Qualité',
    capabilities: 'Capacités',
    statistics: 'Statistiques',
    resolution: 'Résolution :',
    frameRate: 'Fréquence d\'images :',
    bitrate: 'Débit binaire :',
    packetsLost: 'Paquets perdus :',
    qualities: {
      low: 'Basse',
      medium: 'Moyenne',
      high: 'Haute'
    }
  },
  waitingRoom: {
    title: 'Salle',
    titleAccent: "d'Attente",
    sync: "Synchronisation avec le serveur de file d'attente...",
    intro: 'Un médecin vous prendra en charge dès que possible.',
    position: 'Position',
    minutes: 'Minutes estimées',
    noWaitTime: "Temps d'attente non disponible",
    alert: 'Alerte',
    lastUpdate: 'Dernière Mise à jour',
    refreshBtn: 'Actualiser le statut',
    leaveBtn: 'Quitter la file',
    ariaNotificationsOn: 'Notifications activées',
    ariaNotificationsOff: 'Notifications désactivées',
    ariaCancel: 'Annuler et quitter la file d\'attente'
  },
  medicalMetrics: {
    recentConsultations: "Consultations récentes",
    upcomingAppointments: "Rendez-vous à venir",
    activePrescriptions: "Ordonnances actives",
    emergencyContacts: "Contacts d'urgence",
    vitalSigns: "Signes Vitaux",
    heartRate: "Fréquence cardiaque",
    temperature: "Température",
    bloodPressure: "Tension artérielle",
    weight: "Poids",
    lastUpdated: "Dernière mise à jour : {{date}}",
    medicalReminder: "Rappel médical",
    medicalReminderText: "N'oubliez pas de prendre vos médicaments et de respecter vos rendez-vous de suivi. En cas d'urgence, contactez le 15 ou votre médecin traitant.",
    trendUp: "En hausse",
    trendDown: "En baisse",
    trendStable: "Stable"
  },
  doctorQueue: {
    title: 'File',
    titleAccent: 'Active',
    patientsWaitingCount: '{{count}} patient(s) en attente • Séquence Temps Réel',
    syncing: 'Synchronisation du flux...',
    zeroWait: 'Zéro',
    zeroWaitAccent: 'Attente',
    zeroWaitDesc: 'Le flux clinique est parfaitement géré. Excellence opérationnelle atteinte.',
    waitingTimeMin: "{{count}} MIN D'ATTENTE",
    declaredSymptoms: 'Symptomatologie Déclarée',
    rejectionPlaceholder: 'Raison clinique du rejet...',
    irreversibleAction: 'Action Irréversible : Retrait Définitif',
    startClinicalAct: "Démarrer l'acte clinique"
  },
  waitingRoomPatient: {
    tips: [
      "Assurez-vous d'être dans un endroit calme pour votre expertise.",
      "Préparez vos derniers bilans biologiques si disponibles.",
      "Vérifiez que votre éclairage est suffisant pour la vidéo.",
      "Respirez calmement, votre médecin arrive bientôt.",
      "Ekose.Rx garantit le cryptage de bout en bout de cet échange."
    ],
    secureLinkEstablished: 'Liaison sécurisée établie',
    interruptedByDoctor: 'Expertise interrompue par le praticien',
    accessHealthCockpit: 'Accéder au Cockpit de Santé',
    cancelExpertise: "Annuler l'Expertise",
    priorityRoom: "Salle d'Attente Prioritaire",
    connection: 'Connexion',
    imminent: 'Imminente.',
    cockpitSync: 'Votre cockpit médical est en cours de synchronisation avec le praticien disponible.',
    queuePositionLabel: 'Position File',
    priority: 'Prioritaire',
    hdsRank: 'Rang HDS',
    elapsedTime: 'Temps écoulé',
    referringDoctor: 'Médecin référent',
    expectedDuration: 'Durée prévue',
    durationMinutes: '{{count}} minutes',
    encryptedLinkActive: 'Liaison Chiffrée Active',
    medicalGatewayOpen: 'Passerelle Médicale Ouverte',
    hdVideo: 'Vidéo Haute Définition',
    acousticIsolation: 'Isolation Acoustique active',
    aesEncryption: 'Cryptage AES-256 GCM',
    leaveSanctuary: 'Quitter le Sanctuaire'
  },
  waitingRoomDoctor: {
    systemAlert: 'Alerte Système',
    priorityMode: 'Mode Prioritaire',
    liveSynced: 'Live Synchronisé',
    titleAccent: "D'Attente",
    subtitle: 'Orchestration clinique en temps réel',
    total: 'Total',
    patients: 'Patients',
    secureChannelConnecting: 'Canal Sécurisé en cours de liaison...',
    priorityPatient: 'Patient Prioritaire',
    waitingTimeLabel: 'Attente :',
    chatBtn: 'Chatter',
    startSession: 'Lancer la Session',
    queueLocked: 'File Verrouillée',
    clinicalSilence: 'Silence Clinique',
    emptyRoomDesc: "Votre salle d'attente est actuellement vide. Nous optimisons vos ressources en attendant le prochain patient.",
    aiBranding: 'Intelligence Artificielle EKOSE',
    autoPrioritizationActive: 'Priorisation automatique active',
    clinicalArchives: 'Archives Cliniques'
  },
  paymentModal: {
    successMsg: 'Paiement initié avec succès. Veuillez vérifier votre mobile.',
    errorMsg: "Erreur lors de l'initiation du paiement. Veuillez réessayer.",
    title: 'Paiement Sécurisé',
    amountToPay: 'Montant à régler : {{amount}} CFA',
    selectMethod: 'Sélectionnez votre moyen de paiement :',
    fedapayLabel: 'FedaPay (Carte Bancaire / Mobile Money BJ)',
    campayLabel: 'CampPay (Wave / Mobile Money Afrique Centrale)',
    redirecting: 'Redirection...',
    payNow: 'Payer maintenant'
  },
  notFound: {
    title: '404 - Page introuvable',
    desc: "Désolé, la page que vous recherchez n'existe pas.",
    goBack: 'Retourner au tableau de bord'
  },
  unauthorized: {
    title: '403 - Accès refusé',
    desc: "Vous n'avez pas les autorisations nécessaires pour accéder à cette page."
  },
  icd10: {
    searchPlaceholder: 'Chercher un diagnostic...',
    noResults: 'Aucun résultat trouvé'
  },
  patientHistory: {
    loadError: "Échec du chargement de l'historique",
    loading: 'Récupération des antécédents...',
    noHistory: 'Aucun antécédent répertorié',
    timeline: 'Timeline Clinique',
    diagnosis: 'Diagnostic',
    recommendations: 'Recommandations',
    viewFullRecord: 'Consulter le dossier complet'
  },
  emergencyButton: {
    btnTitle: 'Urgence médicale',
    btnAriaLabel: "Bouton d'urgence médicale",
    defaultDesc: "Urgence signalée par l'utilisateur",
    locationUnavailable: 'Localisation non disponible',
    modalTitle: 'Alerte',
    modalTitleAccent: 'Rouge',
    modalSubtitle: "Protocole d'assistance immédiate",
    form: {
      typeLabel: "Nature de l'urgence",
      typeSelect: 'SÉLECTIONNER UNE OPTION...',
      descLabel: 'Précisions additionnelles',
      descPlaceholder: 'Circonstances, antécédents pertinents...'
    },
    types: {
      cardiac: 'Arrêt cardiaque / Douleur thoracique',
      respiratory: 'Difficulté respiratoire sévère',
      unconscious: 'Perte de conscience',
      bleeding: 'Hémorragie importante',
      allergic: 'Choc allergique',
      other: 'Autre urgence grave'
    },
    warningText: "Attention : n'utilisez ce bouton qu'en cas de danger de mort imminent. Un appel direct sera lancé vers le ",
    calling: 'APPEL EN COURS...',
    callBtn: 'CONTACTER LE {{number}}',
    networkError: 'Erreur réseau, appelez le {{number}}.'
  },
  networkIndicator: {
    reconnectingAttempts: 'Reconnexion... ({{attempt}}/5)',
    latency: 'Latence :',
    quality: 'Qualité :',
    status: 'Statut :',
    reconnecting: 'Reconnexion...',
    reconnectBtn: 'Reconnecter',
    unstableConnection: 'Connexion instable',
    unstableDesc: 'Tentative de reconnexion en cours... Vos données sont sauvegardées.',
    qualities: {
      excellent: 'Excellente',
      good: 'Bonne',
      poor: 'Faible'
    }
  },
  peerCall: {
    preparingRoom: "Préparation de la salle d'expertise...",
    expertAdvice: "Avis d'Expertise",
    placeholderDesc: 'Le partage de dossier et les messages chiffrés apparaîtront ici.'
  },
  loadbalancing: {
    loadingDashboard: 'Chargement du tableau de bord...',
    title: 'Répartition',
    titleAccent: 'Intelligente',
    subtitle: 'Optimisation algorithmique de la charge de travail médicale',
    metrics: {
      availableDoctors: 'Médecins Dispo',
      outOf: 'Sur {{total}}',
      queue: "File d'Attente",
      patientsWaiting: 'Patients en attente',
      averageWait: 'Attente Moyenne',
      realTimeEst: 'Estimation temps réel',
      throughput: 'Débit Horaire',
      consultationsPerHour: 'Consultations / h'
    },
    request: {
      title: 'Demande de',
      titleAccent: 'Consultation',
      urgency: "Niveau d'Urgence",
      speciality: 'Spécialité Préférée',
      noPreference: 'Aucune préférence',
      processing: 'Algorithme en cours...',
      submit: 'Demander une Consultation'
    },
    patient: {
      activeTitle: 'Patient',
      activeTitleAccent: 'Actif',
      position: 'Position #{{position}}',
      estimatedWait: 'Attente estimée : {{time}} min',
      doctorAssigned: 'Médecin Assigné !',
      imminentTakeover: 'Prise en charge imminente',
      cancelRequest: 'Annuler la Demande'
    },
    doctor: {
      title: 'Tableau de Bord Médecin',
      statusLabel: 'Statut :',
      patientsWaiting: 'Patients en Attente',
      noPatients: 'Aucun patient en attente'
    },
    doctorsList: {
      title: 'Praticiens',
      titleAccent: 'Actifs',
      load: 'Charge :',
      noDoctors: 'Zéro praticien actif',
      status: {
        available: 'Dispo',
        busy: 'Occupé',
        offline: 'Offline'
      }
    }
  },
  clinicalEditor: {
    title: 'Documentation Clinique',
    saveNow: 'Sauvegarder maintenant',
    autoSaveActive: 'Sauvegarde automatique active',
    notesLabel: 'Notes Internes (Privées)',
    diagnosisLabel: 'Conclusion Médicale (Rapport PDF)',
    adviceLabel: 'Recommandations (Partagées)',
    notesPlaceholder: 'Notes cliniques, observations physiques...',
    diagnosisPlaceholder: 'Énoncez le diagnostic final...',
    advicePlaceholder: 'Médicaments, posologie, conseils de vie...',
    status: {
      idle: 'Prêt',
      saving: 'Sauvegarde...',
      saved: 'Enregistré',
      error: 'Erreur de sauvegarde'
    },
    tabs: {
      observation: 'Observation',
      diagnosis: 'Diagnostic',
      advice: 'Conseils'
    }
  },
  patientSettings: {
    profile: {
      vitalTitle: 'État Civil & Santé',
      birthDate: 'Date de Naissance',
      locationTitle: 'Localisation'
    },
    security: {
      title: "Contrôle d'Accès",
      badge: 'Cryptage Militaire',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer nouveau',
      minChars: 'Min. 8 caractères',
      validateBtn: 'Valider les nouveaux accès'
    },
    emergency: {
      title: "Unités d'Urgence (ICE)",
      badge: 'Protocole Vital',
      contactName: 'Identité du Contact',
      directLine: 'Ligne Directe',
      civilRelation: 'Relation Civile',
      selectRelation: 'Sélectionner...',
      namePlaceholder: 'Nom & Prénom',
      relations: {
        parent: 'Parent Biologique',
        spouse: 'Conjoint(e)',
        child: 'Descendant Direct',
        sibling: 'Fratrie',
        friend: 'Cercle Proche',
        other: 'Mandataire Tiers'
      }
    }
  },
  healthOnboarding: {
    langFr: 'Français',
    langEn: 'Anglais',
    welcomeDoctor: 'Bienvenue Confrère, ',
    welcomePatient: 'Bienvenue sur Ekose-Rx, ',
    welcomeDoctorDesc: 'Votre cabinet numérique Ekose-Rx est prêt à être configuré. Prenons 2 minutes pour finaliser votre identité professionnelle et sécuriser vos téléconsultations.',
    welcomePatientDesc: 'Votre santé est notre priorité. Configurons votre dossier médical numérique de façon ludique et sécurisée pour une prise en charge sur mesure ! 🚀',
    hdsNotice: 'Toutes vos données sont chiffrées de bout-en-bout et conformes aux normes de santé (HDS).',
    letsGo: "C'est parti",
    step1DoctorTitle: 'Identité Professionnelle & Localisation',
    step1PatientTitle: 'Informations & Localisation',
    step1DoctorSubtitle: 'Vérifions vos accréditations',
    step1PatientSubtitle: 'Faisons connaissance !',
    specialty: 'Spécialité',
    specialtyPlaceholder: 'Ex: Cardiologue...',
    licenseNumber: 'Numéro RPPS / Licence',
    licenseNumberPlaceholder: "Votre numéro d'ordre",
    birthDate: 'Date de naissance',
    gender: 'Genre',
    select: 'Sélectionner',
    genderMale: 'Homme',
    genderFemale: 'Femme',
    genderOther: 'Autre',
    yourLocation: 'Votre Localisation',
    country: 'Pays',
    selectCountry: 'Sélectionner un pays',
    region: 'Région / Province',
    city: 'Ville',
    back: 'Retour',
    next: 'Suivant',
    step2Title: 'Connectivité & Sécurité',
    step2DoctorSubtitle: 'Restons en contact professionnel',
    step2PatientSubtitle: 'En cas de besoin...',
    phoneLabel: 'Votre numéro de téléphone (WhatsApp si possible)',
    phonePlaceholder: '+237 6XX XX XX XX',
    iceTitle: 'Personne de confiance (Urgence)',
    iceNamePlaceholder: 'Nom du proche',
    icePhonePlaceholder: 'Téléphone',
    iceRelationPlaceholder: 'Relation (Parent, Conjoint, etc.)',
    step3Title: 'Votre Profil Médical',
    step3PatientSubtitle: 'Votre carnet de santé digital',
    bloodGroup: 'Groupe Sanguin',
    bloodGroupUnknown: 'Je ne sais pas',
    allergies: 'Allergies connues (médicaments, aliments...)',
    allergiesPlaceholder: 'Ex: Pénicilline, Arachides... Laissez vide si aucune.',
    stepHardwareTitle: 'Téléconsultation',
    stepHardwareSubtitle: 'Test Audio & Vidéo',
    stepHardwareDesc: 'Pour garantir une téléconsultation fluide, vérifions que votre caméra et votre micro fonctionnent correctement.',
    hardwareConnectBtn: 'Autoriser la caméra et le micro',
    hardwareConnecting: 'Connexion...',
    hardwareSuccess: 'Équipement fonctionnel !',
    hardwareFinishBtn: "Terminer l'Onboarding",
    hardwareFinishing: 'Finalisation...',
    hdsFooter: 'Données protégées par le secret médical • Ekose-Rx v2.0'
  },
  userPermissions: {
    title: 'Vérification des Permissions',
    subtitle: "Tester les permissions d'un utilisateur",
    verifyBtn: 'Vérifier',
    actionsTitle: 'Actions Utilisateur',
    viewPermissionsTitle: 'Voir Permissions Utilisateur',
    viewPermissionsDesc: 'Consulter les permissions effectives',
    userIdPlaceholder: 'ID Utilisateur',
    consultBtn: 'Consulter',
    assignRoleTitle: 'Assigner un Rôle',
    assignRoleDesc: "Changer le rôle d'un utilisateur",
    userQueryLabel: 'ID Utilisateur',
    userQueryPlaceholder: "Entrez l'ID utilisateur",
    resourceLabel: 'Resource (optionnel)',
    resourcePlaceholder: 'Sélectionner une resource',
    actionLabel: 'Action (optionnel)',
    actionPlaceholder: 'Sélectionner une action',
    verifying: 'Vérification...',
    resultsTitle: 'Résultats',
    resultUser: 'Utilisateur :',
    resultGranted: 'Permission accordée :',
    resultChecked: 'Permissions vérifiées :',
    resultYes: 'Oui',
    resultNo: 'Non',
    permissionsOf: 'Permissions de {{name}}',
    userInfos: 'Informations utilisateur',
    userEmail: 'Email :',
    userRole: 'Rôle :',
    roleDesc: 'Description du rôle',
    effectivePermissionsTitle: 'Permissions effectives ({{count}})'
  },
  financialReports: {
    title: 'Rapports Financiers',
    subtitle: 'Analyse des revenus et performances économiques',
    daysCount_one: '{{count}} jour',
    daysCount_other: '{{count}} jours',
    yearCount_one: '{{count}} an',
    yearCount_other: '{{count}} ans',
    refreshBtn: 'Actualiser',
    tabOverview: "Vue d'ensemble",
    tabTrends: 'Tendances',
    tabAnalytics: 'Analytics',
    tabExport: 'Export',
    kpiRevenue: 'Revenus Totaux',
    kpiMargin: 'Marge',
    kpiPatients: 'Patients Actifs',
    kpiDoctors: 'Médecins',
    revenueEvolution: 'Évolution des Revenus',
    revenueSources: 'Sources de Revenus',
    sourceConsultations: 'Consultations',
    sourcePrescriptions: 'Prescriptions',
    sourceOther: 'Autres',
    patientMetrics: 'Métriques Patients',
    avgRevenuePatient: 'Revenus moyens par patient',
    newPatients: 'Nouveaux patients',
    retentionRate: 'Taux de rétention',
    trendsTitle: 'Tendances sur 12 mois',
    thPeriod: 'Période',
    thConsultations: 'Consultations',
    thPrescriptions: 'Prescriptions',
    thTotal: 'Total',
    thNewPatients: 'Nouveaux Patients',
    ageSegmentation: 'Segmentation par âge',
    ageRange: '{{range}} ans',
    revenueSpecialty: 'Revenus par spécialité',
    consultationsCount_one: '{{count}} consultation',
    consultationsCount_other: '{{count}} consultations',
    patientEngagement: 'Engagement Patients',
    totalPatients: 'Patients totaux',
    recurringPatients: 'Patients récurrents',
    avgConsultationsPatient: 'Consultations moyennes',
    exportTitle: 'Export de données',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    reportType: 'Type de rapport',
    detailedReport: 'Rapport détaillé',
    summaryReport: 'Résumé',
    trendsReport: 'Tendances',
    format: 'Format',
    exporting: 'Export en cours...',
    exportStartBtn: "Lancer l'export",
    exportSuccess: 'Export programmé avec succès',
    exportError: 'Erreur lors du chargement des rapports financiers',
    selectDatesError: 'Veuillez sélectionner les dates de début et fin'
  },
  webRtcMonitor: {
    monitorInactiveTitle: 'WebRTC Non Actif',
    monitorInactiveDesc: 'Aucune session de téléconsultation en cours',
    monitorInactiveSub: "Le monitoring WebRTC s'activera automatiquement lors du démarrage d'une consultation vidéo",
    title: 'Monitoring WebRTC',
    subtitle: 'Session active - Métriques temps réel',
    online: 'En ligne',
    bandwidth: 'Bande Passante',
    upload: 'Upload',
    download: 'Download',
    videoQuality: 'Qualité Vidéo',
    resolution: 'Résolution',
    frameRate: 'Frame Rate',
    bitrate: 'Bitrate',
    network: 'Réseau',
    latency: 'Latence (RTT)',
    packetLoss: 'Perte paquets',
    jitter: 'Jitter',
    audio: 'Audio',
    sampleRate: 'Sample Rate',
    trends: 'Tendances (Dernières mesures)',
    collecting: 'Collecte des données historiques en cours...',
    collectingSub: 'Les graphiques apparaîtront après quelques mesures',
    performanceReport: 'Rapport de Performance',
    recommendations: 'Recommandations',
    highLatency: 'Latence élevée détectée',
    highLatencyDesc: 'Vérifiez la connexion réseau du patient et du médecin',
    highPacketLoss: 'Perte de paquets importante',
    highPacketLossDesc: 'La qualité de la consultation peut être affectée',
    lowBandwidth: 'Bande passante limitée',
    lowBandwidthDesc: 'Considérez réduire la qualité vidéo pour améliorer la stabilité',
    optimalConnection: 'Excellente qualité de connexion',
    optimalConnectionDesc: 'Toutes les métriques sont dans les plages optimales'
  },
  mfaSetup: {
    title: 'Authentification à deux facteurs',
    subtitle: 'Renforcez la sécurité de votre compte avec une vérification supplémentaire',
    step1Title: 'Étape 1/3 - Introduction',
    downloadTitle: "Téléchargez une app d'authentification",
    downloadDesc: "Google Authenticator, Authy, Microsoft Authenticator, ou toute app TOTP",
    scanTitle: 'Scannez le QR code',
    scanDesc: 'Utilisez votre téléphone pour scanner le code QR qui sera généré',
    verifyTitle: 'Vérifiez avec un code',
    verifyDesc: 'Entrez le code à 6 chiffres généré par votre app',
    skipBtn: 'Plus tard',
    startBtn: 'Commencer',
    loadingStart: 'Configuration...',
    step2Title: 'Étape 2/3 - Configuration',
    scanQrTitle: 'Scannez ce QR code',
    scanQrDesc: "Ouvrez votre application d'authentification et scannez ce code QR",
    manualKeyDesc: 'Si vous ne pouvez pas scanner le QR code, saisissez manuellement cette clé :',
    step3Title: 'Étape 3/3 - Vérification',
    verifyConfigTitle: 'Vérifiez votre configuration',
    verifyInputLabel: 'Code de vérification',
    loadingVerify: 'Vérification...',
    successTitle: 'MFA activé avec succès !',
    successDesc: 'Votre compte est maintenant protégé par une authentification à deux facteurs.',
    backupCodesTitle: 'Codes de récupération',
    backupCodesDesc: 'Sauvegardez ces codes dans un endroit sûr. Ils vous permettront de récupérer l\'accès à votre compte si vous perdez votre téléphone.',
    backupCodesWarning: '⚠️ Ces codes ne seront affichés qu\'une seule fois',
    completeBtn: 'Accéder à mon compte',
    backToLogin: '← Retour à la connexion',
    defaultError: 'Erreur lors de la configuration MFA',
    invalidCodeError: 'Code de vérification invalide'
  },
  monitoringDashboard: {
    title: 'Monitoring Avancé',
    recentAlerts: '🚨 Alertes Récentes',
    webrtc: '📹 WebRTC',
    chat: '💬 Chat',
    performance: '⚡ Performance',
    security: '🔒 Sécurité',
    exporter: '📊 Exporter',
    uptime: 'Uptime',
    reconnections: 'Reconnexions',
    cpu: 'CPU',
    memory: 'Mémoire',
    failedLogins: 'Connexions échouées',
    suspiciousAct: 'Activités suspectes',
    encFailures: 'Échecs chiffrement',
    dataAccess: 'Accès données',
    messagesSent: 'Envoyés',
    messagesReceived: 'Reçus',
    responseTime: 'Temps réponse',
    encryptionLatency: 'Chiffrement',
    monitoringTitle: 'Monitoring EKOSE',
    monitoringDesc: 'Surveillance temps réel des performances système',
    systemMetrics: 'Mémoire',
    description: 'Surveillance temps réel des performances système',
    healthStatus: 'Statut global :',
    autoRefresh: 'Auto-refresh',
    refresh: 'Actualiser',
    export: 'Exporter',
    lastUpdate: 'Dernière mise à jour : {{time}}',
    tabOverview: 'Vue d\'ensemble',
    tabWebRtc: 'WebRTC',
    tabWaiting: 'Salle d\'attente',
    tabAlertes: 'Alertes',
    resolvedToast: 'Alerte résolue',
    refreshedToast: 'Métriques actualisées',
    exportedToast: 'Rapport exporté',
    memoryTitle: 'Mémoire',
    webrtcRttTitle: 'WebRTC RTT',
    webrtcRttDesc: 'Latence réseau',
    usersTitle: 'Utilisateurs',
    usersDesc: 'Actifs maintenant',
    consultationsTitle: 'Consultations',
    consultationsDesc: 'En cours',
    webrtcTitle: 'Métriques WebRTC',
    webrtcUpload: 'Upload',
    webrtcDownload: 'Download',
    webrtcFrameRate: 'Frame Rate',
    webrtcNoSession: 'Aucune session WebRTC active',
    waitingRoomTitle: 'Salle d\'Attente',
    waitingPosition: 'Position',
    waitingEstimation: 'Estimation',
    waitingDoctor: 'Médecin',
    waitingStatus: 'Statut',
    waitingRecentNotifs: 'Notifications récentes',
    waitingNoActive: 'Aucune salle d\'attente active',
    alertsTitle: 'Alertes Système ({{count}})',
    alertsResolvedBtn: 'Résoudre',
    alertsNoActive: 'Aucune alerte active',
    alertsAllHealthy: 'Tous les systèmes fonctionnent normalement'
  },
  userFilters: {
    advancedFilters: 'Filtres avancés',
    closeAria: 'Fermer la fenêtre de filtres',
    close: 'Fermer',
    roleLabel: 'Rôle',
    allRoles: 'Tous les rôles',
    statusLabel: 'Statut',
    allStatus: 'Tous les statuts',
    statusActive: 'Actif',
    statusInactive: 'Inactif',
    statusSuspended: 'Suspendu',
    statusPending: 'En attente',
    activeLabel: 'Actif',
    all: 'Tous',
    verifiedLabel: 'Vérifié',
    verifiedTrue: 'Vérifié',
    verifiedFalse: 'Non vérifié',
    dateFromLabel: "Date d'inscription (début)",
    dateToLabel: "Date d'inscription (fin)",
    loginFromLabel: 'Dernière connexion (début)',
    loginToLabel: 'Dernière connexion (fin)',
    searchLabel: 'Recherche',
    searchPlaceholder: 'Rechercher par nom ou email...',
    resetBtn: 'Réinitialiser',
    applyBtn: 'Appliquer les filtres',
    searchPlaceholderSimple: 'Rechercher (nom, email...)',
    filterRoleAria: 'Filtrer par rôle',
    filterStatusAria: 'Filtrer par statut',
    roleAdmin: 'Administrateurs',
    roleDoctor: 'Médecins',
    rolePatient: 'Patients',
    statusActivePlural: 'Actifs',
    statusInactivePlural: 'Inactifs'
  },
  consultationShared: {
    loadingTitle: 'Chargement sécurisé',
    loadingDesc: 'Veuillez patienter...',
    errorTitle: 'Une erreur est survenue',
    errorBackHome: "Retour à l'accueil",
    sessionNotFound: 'Session introuvable',
    sessionNotFoundDesc: "Cette consultation n'existe plus ou a été clôturée.",
    sessionNotFoundBtn: 'Quitter',
    readyTitleDoctor: 'Prêt pour la consultation ?',
    readyTitlePatient: 'Vérification de sécurité',
    endedTitle: 'Téléconsultation terminée',
    endedDesc: 'Liaison sécurisée clôturée avec succès.',
    endedSaveSuccess: 'Observations enregistrées avec succès',
    secureLine: 'EKOSE Secure Line',
    secureLineUptodate: 'Connexion sécurisée établie',
    networkOffline: 'Connexion perdue — vos données sont sauvegardées localement',
    networkReconnecting: 'Reconnexion en cours... (tentative {{count}}/5)',
    networkUnstable: 'Connexion instable — la qualité vidéo a été réduite',
    retryBtn: 'Réessayer',
    protectionTitle: 'EKOSE PROTECTION',
    videoQualityDetail: 'Vidéo : 1080p 30fps',
    audioQualityDetail: 'Audio : Opus 48kHz',
    networkLatencyDetail: 'Réseau : Excellent (12ms)',
    initializingSession: 'Initialisation...',
    initializingSessionDesc: 'La session va démarrer automatiquement.',
    messagesTab: 'Messages',
    notesTab: 'Notes',
    notesTitle: 'Dossier Séance',
    notesLabel: 'Diagnostic & Observations',
    notesPlaceholder: 'Notez vos observations cliniques...',
    notesRecommendations: 'Recommandations & Suivi',
    notesRecPlaceholder: 'Prescriptions, repos, prochain rdv...',
    saveAndEndBtn: 'Enregistrer & Clôturer'
  },
  prescriptionForm: {
    selectPatientTitle: 'Sélectionner un Patient',
    searchPatientPlaceholder: 'Rechercher par nom ou numéro court...',
    noPatientFound: 'Aucun patient trouvé',
    prescriptionFor: 'Prescription pour :',
    changeBtn: 'Changer',
    therapeuticPlan: 'Plan Thérapeutique',
    addMedicineBtn: 'Ajouter un médicament',
    medicineLabel: 'Médicament',
    medicinePlaceholder: 'ex: Paracétamol',
    dosageLabel: 'Dosage',
    dosagePlaceholder: 'ex: 1g',
    frequencyLabel: 'Fréquence',
    frequencyPlaceholder: 'ex: 3x / jour',
    durationLabel: 'Durée',
    durationPlaceholder: 'ex: 7 jours',
    allergyNotes: "Notes d'allergies",
    allergyPlaceholder: 'Précisez les contre-indications éventuelles...',
    urgencyTitle: "Degré d'Urgence",
    urgencyStandard: 'Standard',
    urgencyPriority: 'Prioritaire',
    urgencyUrgent: 'Urgent',
    signedElectronically: 'Signé électroniquement par Dr. {{name}}',
    abortBtn: 'Abandonner',
    certifyBtn: 'Certifier & Transmettre',
    certifySuccess: 'Prescription certifiée et transmise avec succès',
    selectPatientErr: 'Veuillez sélectionner un patient',
    fillMedicinesErr: 'Veuillez remplir au moins le nom et le dosage pour chaque médicament',
    noPatientSelected: 'Aucun'
  },
  securityLogs: {
    eventTypeLabel: 'Événement',
    severityLabel: 'Sévérité',
    ipLabel: 'IP',
    endpointLabel: 'Endpoint',
    statusLabel: 'Statut',
    dateLabel: 'Date',
    actionsLabel: 'Actions',
    loadingLogs: 'Chargement des logs...',
    noLogsFound: 'Aucun log de sécurité trouvé',
    allTypes: 'Tous types',
    allSeverities: 'Toutes sévérités',
    severityLow: 'Faible',
    severityMedium: 'Moyenne',
    severityHigh: 'Élevée',
    severityCritical: 'Critique',
    ipPlaceholder: 'Adresse IP...',
    totalLogs: 'Total Logs',
    blockedLogs: 'Bloqués',
    criticalLogs: 'Critiques',
    highLogs: 'Élevés',
    viewDetailsTitle: 'Voir les détails'
  },
  medicalCompliance: {
    consentTitle: 'Consentement Médical',
    consentDesc: 'En utilisant cette plateforme de téléconsultation, vous consentez à :',
    consentBullet1: 'Partager vos informations médicales avec les professionnels de santé',
    consentBullet2: 'Recevoir des soins via téléconsultation',
    consentBullet3: 'Être contacté par les professionnels de santé pour votre suivi',
    consentBullet4: "Participer à l'amélioration des soins (données anonymisées)",
    consentImportant: 'Important : Vous pouvez retirer votre consentement à tout moment en contactant notre équipe ou en modifiant vos paramètres de confidentialité.',
    privacyTitle: 'Politique de Confidentialité',
    privacyDesc: 'Vos données médicales sont protégées selon les standards les plus élevés :',
    privacyBullet1: 'Chiffrement de bout en bout pour toutes les communications',
    privacyBullet2: 'Stockage sécurisé conforme au RGPD et aux standards médicaux',
    privacyBullet3: 'Accès restreint aux seuls professionnels autorisés',
    privacyBullet4: 'Audit régulier de sécurité et de conformité',
    privacyBullet5: "Droit d'accès, de rectification et de suppression de vos données",
    securityTitle: 'Sécurité des Données',
    securityCertTitle: 'Certifications',
    securityCertBullet1: '• ISO 27001 (Sécurité)',
    securityCertBullet2: '• HDS (Hébergeur de Données de Santé)',
    securityCertBullet3: '• RGPD conforme',
    securityProtTitle: 'Protection',
    securityProtBullet1: '• Chiffrement AES-256',
    securityProtBullet2: '• Authentification 2FA',
    securityProtBullet3: '• Sessions sécurisées',
    auditTitle: 'Traçabilité et Audit',
    auditDesc: 'Toutes les actions médicales sont tracées pour assurer la qualité des soins :',
    auditBullet1: 'Horodatage de toutes les consultations',
    auditBullet2: 'Traçabilité des prescriptions et modifications',
    auditBullet3: "Journal d'audit accessible aux autorités compétentes",
    auditBullet4: 'Conservation des données selon la réglementation',
    checkboxReadPrivacy: "J'ai lu et compris la politique de confidentialité",
    checkboxConsent: "J'accepte les conditions de téléconsultation",
    acceptBtn: 'Accepter',
    declineBtn: 'Refuser',
    certifiedBadge: 'Conformité médicale certifiée'
  },
  settingsPage: {
    title: 'Paramètres',
    notifications: 'Notifications',
    emailNotifications: 'Notifications par email',
    emailNotificationsDesc: 'Recevoir les notifications importantes par email',
    pushNotifications: 'Notifications push',
    pushNotificationsDesc: 'Recevoir les notifications dans le navigateur',
    security: 'Sécurité',
    changePassword: 'Changer le mot de passe',
    changePasswordDesc: 'Mettre à jour votre mot de passe',
    twoFactorAuth: 'Authentification à deux facteurs',
    twoFactorAuthDesc: 'Ajouter une couche de sécurité supplémentaire',
    languageRegion: 'Langue et région',
    languageLabel: 'Langue',
    timezoneLabel: 'Fuseau horaire',
    appearance: 'Apparence',
    themeLabel: 'Thème',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    themeAuto: 'Automatique',
    saveChanges: 'Enregistrer les modifications',
    cancel: 'Annuler',
    error: 'Erreur',
    unrecognizedRole: 'Rôle utilisateur non reconnu : {{role}}'
  },
  systemMonitor: {
    title: 'Surveillance Système',
    refresh: 'Actualiser',
    export: 'Exporter',
    details: 'Détails',
    collapse: 'Réduire',
    summaryTitle: 'Résumé rapide',
    systemLabel: 'Système',
    databaseLabel: 'Base de données',
    auditLabel: 'Audit',
    apiLabel: 'API EKOSE',
    lastUpdate: 'Dernière mise à jour : {{date}}',
    recommendationsTitle: 'Recommandations :',
    systemHealthTitle: 'Santé du système',
    statusLabel: 'Statut :',
    responseTimeLabel: 'Temps de réponse :',
    activeUsersLabel: 'Utilisateurs actifs :',
    errorRateLabel: 'Taux d\'erreur :',
    databaseTitle: 'Base de données',
    dbConnectedLabel: 'Connectée :',
    dbSizeLabel: 'Taille :',
    dbTablesLabel: 'Tables :',
    auditTitle: 'Conformité audit',
    auditCompliantLabel: 'Conforme :',
    auditTotalEventsLabel: 'Total événements :',
    auditEventsTodayLabel: 'Événements aujourd\'hui :',
    auditLastLabel: 'Dernier audit :',
    userActionsTitle: 'Actions utilisateur',
    actionsLoggedLabel: 'Enregistrées :',
    recentActionsLabel: 'Actions récentes :',
    lastActionLabel: 'Dernière action :',
    userNotConnected: 'Utilisateur non connecté',
    dbConnectionIssue: 'Base de données inaccessible - Vérifier la connexion PostgreSQL',
    systemDegradedIssue: 'Système en état dégradé - Vérifier les services',
    auditComplianceIssue: 'Conformité audit non respectée - Vérifier les logs d\'audit',
    dataPersistenceIssue: 'Vérification de persistance échouée - Vérifier l\'intégrité des données',
    apiConnectivityIssue: 'Connectivité API défaillante - Vérifier l\'API EKOSE-API',
    monitoringSuccess: 'Système en bon état',
    monitoringFailed: 'Erreur lors de la surveillance',
    exportSuccess: 'Rapport exporté avec succès',
    exportFailed: 'Erreur lors de l\'export',
    statusOperational: 'Opérationnel',
    statusFailing: 'Défaillant',
    statusDegraded: 'Dégradé'
  },
  userDetailsModal: {
    title: "Détails de l'utilisateur",
    closeTitle: 'Fermer',
    closeAriaLabel: 'Fermer la fenêtre de détails utilisateur',
    generalInfo: 'Informations générales',
    nameLabel: 'Nom:',
    emailLabel: 'Email:',
    roleLabel: 'Rôle:',
    statusLabel: 'Statut:',
    activeLabel: 'Actif:',
    verifiedLabel: 'Vérifié:',
    emailVerifiedLabel: 'Email vérifié:',
    lastLoginLabel: 'Dernière connexion:',
    registrationLabel: 'Inscription:',
    profileMetrics: 'Profil et métriques',
    profileType: 'Profil {{type}}',
    birthDateLabel: 'Date de naissance:',
    specialityLabel: 'Spécialité:',
    licenseLabel: 'Numéro de licence:',
    insuranceLabel: "Numéro d'assurance:",
    phoneLabel: 'Téléphone:',
    activityMetrics: "Métriques d'activité",
    totalSessions: 'Sessions totales:',
    notificationsLabel: 'Notifications:',
    auditEntries: 'Entrées audit:',
    yes: 'Oui',
    no: 'Non',
    never: 'Jamais'
  },
  userList: {
    selectedCount: '{{count}} sélectionné(s)',
    selectAll: 'Sélectionner tout',
    bulkActions: 'Actions en masse',
    exportCsv: 'Export CSV',
    exportJson: 'Export JSON',
    userHeader: 'Utilisateur',
    roleHeader: 'Rôle',
    statusHeader: 'Statut',
    activityHeader: 'Activité',
    registrationHeader: 'Inscription',
    actionsHeader: 'Actions',
    noUserFound: 'Aucun utilisateur trouvé',
    noNumber: 'Sans numéro',
    activeTooltip: 'Actif',
    inactiveTooltip: 'Inactif',
    verifiedTooltip: 'Vérifié',
    unverifiedTooltip: 'Non vérifié',
    sessionsCount: '{{count}} sessions',
    viewDetails: 'Voir les détails',
    deactivateTooltip: 'Désactiver',
    activateTooltip: 'Activer',
    verifyTooltip: 'Vérifier',
    deleteTooltip: 'Supprimer',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer l\'utilisateur {{name}} ?',
    previous: 'Précédent',
    next: 'Suivant',
    paginationInfo: 'Affichage de {{start}} à {{end}} sur {{total}} résultats',
    pageInfo: 'Page {{page}} sur {{totalPages}}',
    contactHeader: 'Contact',
    lastConnectionHeader: 'Dernière Connexion',
    loadingUsers: 'Chargement des utilisateurs...',
    never: 'Jamais',
    viewDetailsTooltip: "Voir les détails de l'utilisateur",
    promoteTooltip: 'Promouvoir',
    promoteUserTooltip: "Promouvoir l'utilisateur",
    editTooltip: 'Modifier',
    editUserTooltip: "Modifier l'utilisateur",
    deleteUserTooltip: "Supprimer l'utilisateur"
  },
  userBulkActions: {
    title: 'Actions en Masse',
    selectedCount: 'Utilisateurs sélectionnés: {{count}}',
    noSelectionDesc: 'Sélectionnez des utilisateurs dans l\'onglet "Utilisateurs" pour effectuer des actions en masse.',
    selectionDesc: 'Ces actions seront appliquées à tous les utilisateurs sélectionnés.',
    actionToPerform: 'Action à effectuer',
    activateAction: 'Activer les comptes',
    deactivateAction: 'Désactiver les comptes',
    verifyAction: 'Vérifier les comptes',
    unverifyAction: 'Annuler la vérification',
    changeRoleAction: 'Changer le rôle',
    deleteAction: 'Supprimer les comptes (soft delete)',
    newRoleLabel: 'Nouveau rôle',
    rolePatient: 'Patient',
    roleDoctor: 'Médecin',
    roleAdmin: 'Administrateur',
    reasonLabel: "Raison de l'action",
    reasonPlaceholder: 'Expliquez la raison de cette action en masse...',
    applyBtn: 'Appliquer à {{count}} utilisateur(s)',
    loadingBtn: 'Exécution en cours...'
  },
  passwordReset: {
    titleRequest: 'Réinitialiser le mot de passe',
    titleCheckEmail: 'Vérifiez vos emails',
    titleReset: 'Nouveau mot de passe',
    titleSuccess: 'Mot de passe réinitialisé',
    requestDesc: 'Entrez votre adresse email pour recevoir un lien de réinitialisation',
    emailLabel: 'Adresse email',
    emailPlaceholder: 'votre@email.com',
    sendingBtn: 'Envoi en cours...',
    sendBtn: 'Envoyer le lien de réinitialisation',
    checkEmailTitle: 'Vérifiez votre boîte mail',
    checkEmailDesc: 'Nous avons envoyé un email à {{email}} avec les instructions pour réinitialiser votre mot de passe.',
    instructionsTitle: '📧 Que faire maintenant :',
    instructionsStep1: 'Ouvrez l\'email envoyé par EKOSE-Rx',
    instructionsStep2: 'Cliquez sur le lien de réinitialisation',
    instructionsStep3: 'Suivez les instructions pour créer un nouveau mot de passe',
    changeEmailBtn: 'Changer d\'adresse email',
    newPasswordLabel: 'Nouveau mot de passe',
    confirmPasswordLabel: 'Confirmer le nouveau mot de passe',
    passwordPlaceholder: '••••••••',
    updatingBtn: 'Mise à jour...',
    resetPasswordBtn: 'Réinitialiser le mot de passe',
    successTitle: 'Succès',
    successDesc: 'Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter.',
    loginBtn: 'Aller à la page de connexion',
    backToLogin: 'Retour à la connexion',
    emptyFieldsErr: 'Veuillez saisir tous les champs',
    mismatchErr: 'Les mots de passe ne correspondent pas',
    lengthErr: 'Le mot de passe doit contenir au moins 8 caractères',
    formatErr: 'Le mot de passe doit contenir au moins une minuscule, une majuscule, un chiffre et un caractère spécial (@$!%*?&)',
    missingTokenErr: 'Jeton de réinitialisation manquant ou invalide. Veuillez cliquer sur le lien reçu par e-mail.',
    requestFailedErr: 'Erreur lors de l\'envoi de l\'email',
    resetFailedErr: 'Erreur lors de la réinitialisation'
  },
  prescriptionDetailsModal: {
    title: 'Détails de la Prescription #{{number}}',
    closeTooltip: 'Fermer',
    medInfo: 'Informations Médicamenteuses',
    medicationLabel: 'Médicament:',
    genericLabel: 'Nom générique:',
    dosageLabel: 'Dosage:',
    frequencyLabel: 'Fréquence:',
    durationLabel: 'Durée:',
    quantityLabel: 'Quantité:',
    statusValidation: 'Statut et Validation',
    statusLabel: 'Statut:',
    priorityLabel: 'Priorité:',
    controlledLabel: 'Contrôlée:',
    renewableLabel: 'Renouvelable:',
    renewableYes: 'Oui ({{count}} restants)',
    prescribedDateLabel: 'Date de prescription:',
    medInstructions: 'Instructions Médicales',
    indications: 'Indications',
    instructions: 'Instructions',
    contraindications: 'Contre-indications',
    sideEffects: 'Effets secondaires',
    participants: 'Participants',
    patient: 'Patient',
    doctor: 'Médecin',
    pharmacist: 'Pharmacien',
    patientUnknown: 'Patient inconnu',
    doctorUnknown: 'Médecin inconnu',
    validationTitleActive: 'Valider la Prescription',
    validationTitleCancel: 'Annuler la Prescription',
    validationDescActive: 'Confirmer la validation de la prescription de {{patient}} pour {{medication}} ?',
    validationDescCancel: 'Confirmer l\'annulation de la prescription de {{patient}} pour {{medication}} ?',
    adminNotesLabel: 'Notes administratives',
    adminNotesPlaceholder: 'Ajouter des notes administratives...',
    reasonLabel: 'Raison de la {{action}}',
    reasonPlaceholder: 'Expliquez la raison de cette action...',
    abortBtn: 'Annuler',
    processBtn: 'Traitement...',
    confirmActiveBtn: 'Valider',
    confirmCancelBtn: 'Annuler',
    actionValidation: 'validation',
    actionCancellation: 'annulation',
    yes: 'Oui',
    no: 'Non'
  },
  complianceReport: {
    loading: 'Génération du rapport de conformité...',
    noReport: 'Aucun rapport de conformité disponible',
    generateBtn: 'Générer un rapport',
    title: 'Rapport de Conformité',
    generatedAt: 'Généré le {{date}}',
    allRules: 'Toutes les règles',
    rgpdOnly: 'RGPD uniquement',
    hipaaOnly: 'HIPAA uniquement',
    securityOnly: 'Sécurité uniquement',
    refreshBtn: 'Actualiser',
    exportBtn: 'Exporter',
    statusTitle: 'Statut Global: {{status}}',
    statusCompliant: 'Conforme',
    statusPartial: 'Partiellement Conforme',
    statusNonCompliant: 'Non Conforme',
    severityCritical: 'Critiques:',
    severityHigh: 'Élevées:',
    severityMedium: 'Moyennes:',
    severityLow: 'Faibles:',
    rulesPassed: 'règles respectées',
    rulesDetails: 'Détails des Vérifications',
    detailsLabel: 'Détails:',
    recommendationsLabel: 'Recommandations:'
  },
  patientDashboardSections: {
    welcome: 'Bonjour,',
    waitRoomActive: 'Salle d\'attente active',
    waitRoomActiveDesc: 'Votre médecin va vous appeler dans un instant.',
    enterWaitingRoom: 'Entrer en salle d\'attente',
    takeCareTitle: 'Prenez soin de votre santé aujourd\'hui.',
    noConsultation: 'Aucune consultation en attente',
    noConsultationDesc: 'Vous n\'avez pas de téléconsultation planifiée pour le moment.',
    scheduleConsultation: 'Planifier une téléconsultation',
    certifiedHds: 'DONNÉES HDS CHIFFRÉES',
    certifiedHdsDesc: 'Vos données médicales sont stockées de façon sécurisée en conformité avec la réglementation des hébergeurs de données de santé (HDS).',
    ekoseElitePlatform: 'EKOSE ELITE PLATFORM'
  },
  dataExportBackup: {
    title: 'Exports & Sauvegardes',
    subtitle: 'Gestion des données et sécurité système',
    createExport: 'Créer un Export',
    formatLabel: 'Format d\'export',
    formatCsv: 'CSV (feuille de calcul)',
    formatJson: 'JSON (données brutes)',
    exportBtn: 'Lancer l\'export',
    exportingBtn: 'Export en cours...',
    backupSection: 'Sauvegardes Système',
    createBackup: 'Créer une Sauvegarde',
    backupBtn: 'Lancer la sauvegarde',
    backupingBtn: 'Sauvegarde en cours...',
    noBackup: 'Aucune sauvegarde enregistrée',
    dateLabel: 'Date',
    sizeLabel: 'Taille',
    actionsLabel: 'Actions',
    downloadBtn: 'Télécharger',
    restoreBtn: 'Restaurer',
    restoringBtn: 'Restauration...',
    toastExportSuccess: 'Données exportées avec succès',
    toastBackupSuccess: 'Sauvegarde créée avec succès',
    toastRestoreSuccess: 'Système restauré avec succès',
    toastDeleteSuccess: 'Sauvegarde supprimée avec succès'
  },
  errorRecoveryComponents: {
    techDetails: 'Détails techniques',
    errDetails: 'Détails de l\'erreur',
    category: 'Catégorie',
    severity: 'Sévérité',
    strategy: 'Stratégie de récupération',
    retryBtn: 'Réessayer',
    abortBtn: 'Annuler',
    recoveredToast: 'Erreur récupérée avec succès'
  },
  adminErrorDisplay: {
    titles: {
      NETWORK_ERROR: 'Problème de connexion',
      PERMISSION_DENIED: 'Accès refusé',
      NOT_FOUND: 'Ressource introuvable',
      VALIDATION_ERROR: 'Données invalides',
      SERVER_ERROR: 'Erreur serveur',
      UNEXPECTED: 'Erreur inattendue'
    },
    actions: {
      NETWORK_ERROR: 'Vérifiez votre connexion internet et réessayez.',
      PERMISSION_DENIED: "Contactez un administrateur si vous pensez que c'est une erreur.",
      NOT_FOUND: 'Vérifiez que la ressource existe toujours.',
      VALIDATION_ERROR: 'Corrigez les données saisies et réessayez.',
      SERVER_ERROR: 'Le problème sera probablement résolu automatiquement. Réessayez dans quelques minutes.',
      UNEXPECTED: "Réessayez l'opération ou contactez le support."
    },
    retry: 'Réessayer',
    techDetails: 'Détails techniques'
  },
  peerConsultationPanel: {
    title: 'Consultations Peer',
    subtitle: 'Plateforme Collaborative',
    askOpinion: 'Demander Avis',
    noRequest: 'Aucune demande en attente',
    from: 'De:',
    to: 'À:',
    subject: 'Sujet:',
    status: 'Statut:',
    acceptBtn: 'Accepter',
    declineBtn: 'Refuser',
    toastOpinionSent: 'Demande d\'avis envoyée',
    toastOpinionAccepted: 'Demande acceptée',
    toastOpinionDeclined: 'Demande refusée'
  },
  apiMonitoringDashboard: {
    title: '📊 Monitoring API Performances',
    successRate: 'Taux de Succès',
    avgTime: 'Temps Moyen',
    apiInfo: 'ℹ️ Informations API',
    endpoint: 'Endpoint',
    method: 'Méthode',
    calls: 'Appels',
    errors: 'Erreurs',
    averageTime: 'Temps Moyen',
    lastCall: 'Dernier Appel'
  },
  header: {
    messages: 'Messages',
    notifications: 'Notifications',
    myProfile: 'Mon profil',
    settings: 'Paramètres',
    logout: 'Déconnexion'
  },
  sidebar: {
    dashboard: 'Tableau de bord',
    patients: 'Patients',
    consultations: 'Consultations',
    teleconsultations: 'Téléconsultation',
    prescriptions: 'Prescriptions',
    messages: 'Messagerie',
    settings: 'Paramètres',
    elitePlatform: 'Plateforme Elite',
    activeSession: 'Session active',
    logout: 'Déconnexion'
  },
  prescriptionCard: {
    title: 'Ordonnance',
    byDoctor: 'Par {{doctorName}}',
    medications: 'Médicaments'
  },
  appInit: {
    title: 'Initialisation',
    subtitle: 'Séquence Sécurisée Ekose.Rx',
    reconnectFailed: 'Impossible de se reconnecter au serveur',
    serverConnectionError: 'Erreur de connexion au serveur',
    connectionProblem: 'Problème de connexion',
    retry: 'Réessayer'
  },
  deviceCheck: {
    title: 'Vérification de votre équipement',
    subtitle: 'Avant de rejoindre la salle, assurons-nous que tout fonctionne.',
    requestingAccess: "Demande d'accès caméra & micro...",
    requestAccessDesc: 'Veuillez cliquer sur "Autoriser" dans la fenêtre pop-up de votre navigateur.',
    accessDeniedTitle: 'Accès refusé ou équipement manquant',
    howToFix: 'Comment réparer :',
    fixStep1: "Vérifiez que votre caméra/micro n'est pas utilisé par une autre application.",
    fixStep2: 'Cliquez sur l\'icône de cadenas "🔒" à gauche de l\'URL dans votre navigateur et autorisez l\'accès.',
    fixStep3: 'Rechargez ensuite cette page.',
    retry: 'Réessayer',
    videoOk: 'Vidéo OK',
    equipmentReady: 'Votre équipement est prêt.',
    joinRoom: 'Rejoindre la salle',
    errors: {
      permissionDenied: "Vous devez autoriser l'accès à la caméra et au microphone dans votre navigateur pour effectuer la téléconsultation.",
      notFound: "Aucune caméra ou microphone n'a été détecté(e) sur votre appareil.",
      generic: "Impossible d'accéder à votre équipement multimédia. Veuillez vérifier vos branchements."
    }
  },
  dashboard: {
    doctor: {
      callPatientSuccess: 'Le patient a été appelé avec succès',
      callPatientError: "Impossible d'appeler le patient",
      refresh: 'Actualiser',
      newConsultation: 'Nouvelle Consultation',
      emptyWaitingRoom: "Salle d'attente vide",
      emptyWaitingRoomDesc: "Aucun patient n'attend actuellement. Profitez-en pour finaliser vos notes médicales.",
      viewPendingRecords: 'Voir les dossiers en attente',
      patientsToday: "Patients Aujourd'hui",
      vsYesterday: 'vs hier',
      urgentMessages: 'Messages Urgent',
      todayAgenda: 'Agenda du Jour',
      noAppointmentsToday: "Aucun rendez-vous prévu pour aujourd'hui.",
      weeklyVolume: 'Volume Hebdo',
      activityIncrease: "+15% d'activité cette semaine",
      online: 'En ligne',
      disconnected: 'Déconnecté',
      realTimeServices: 'Services Temps Réel',
      wsStable: 'Connexion WebSockets stable',
      wsReconnecting: 'Tentative de reconnexion...'
    }
  },
  adminOnlineView: {
    loading: 'Chargement des utilisateurs en ligne...',
    errorMsg: '❌ Erreur: {{error}}',
    retry: 'Réessayer',
    title: 'Utilisateurs en ligne',
    total: 'Total',
    doctors: 'Médecins',
    patients: 'Patients',
    doctorsOnlineTitle: 'Médecins en ligne ({{count}})',
    patientsOnlineTitle: 'Patients en ligne ({{count}})',
    refreshTooltip: 'Rafraîchir',
    noDoctorOnline: 'Aucun médecin en ligne',
    noPatientOnline: 'Aucun patient en ligne',
    autoUpdateDesc: 'Mise à jour automatique toutes les 30 secondes •',
    refreshNowBtn: 'Rafraîchir maintenant',
    defaultDoctorName: 'Médecin',
    defaultDoctorSpec: 'Médecin',
    defaultPatientName: 'Patient',
    roleAdmin: 'Administrateur',
    rolePatient: 'Patient'
  },
  secureMonitoring: {
    fakeDataDetected: 'Données non réelles détectées',
    loadError: 'Erreur lors du chargement des métriques',
    loadErrorSystem: 'Erreur lors du chargement des métriques système',
    loadErrorAlerts: 'Erreur lors du chargement des alertes',
    uptimeFormat: '{{days}}j {{hours}}h {{minutes}}m',
    accessRestricted: 'Accès Restreint',
    accessRestrictedDesc: 'Cette section est réservée aux administrateurs.',
    loadingMetrics: 'Chargement des métriques système...',
    loadErrorTitle: 'Erreur de chargement',
    noMetricsTitle: 'Aucune métrique disponible',
    noMetricsDesc: 'Les métriques système ne sont pas disponibles pour le moment.',
    retry: 'Réessayer',
    pageTitle: 'Monitoring Système',
    pageDesc: 'Surveillance en temps réel - Données réelles uniquement',
    lastUpdate: 'Dernière mise à jour :',
    systemAlerts: 'Alertes Système',
    uptime: 'Uptime',
    memory: 'Mémoire',
    cpuLoad: 'Charge CPU',
    dbMetricsTitle: 'Métriques Base de Données',
    users: 'Utilisateurs',
    appointments: 'Rendez-vous',
    messages: 'Messages',
    consultations: 'Consultations',
    thisWeek: 'cette semaine',
    redisCache: 'Cache Redis',
    status: 'Statut',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    usedMemory: 'Mémoire utilisée',
    totalKeys: 'Clés totales',
    hitRate: 'Taux de succès'
  },
  dashboardOptimizer: {
    emptyState: 'Aucun élément à afficher',
    metricsError: 'Erreur lors du chargement des métriques'
  },
  virtualizedList: {
    loadingData: 'Chargement des données...'
  }
};




